"use strict";
exports.__esModule = true;
exports.isVoid = void 0;
var ramda_1 = require("ramda");
var isVoid = function (obj) {
    return ramda_1.isEmpty(obj) || ramda_1.isNil(obj);
};
exports.isVoid = isVoid;
//# sourceMappingURL=isVoid.js.map